import Button from 'tio-ui/components/button';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { NotificationsService } from 'tio-ui/components/notifications';
import type { ButtonAppearance, ButtonIntent, ButtonSize } from 'tio-ui/components/button';
import { PhFiles } from 'ember-phosphor-icons';

export interface UiCopyButtonSignature {
  Element: HTMLElement;
  Args: {
    text: string;
    title?: string;
    /** Button chrome overrides; each defaults to the icon-only pill's look. */
    intent?: ButtonIntent;
    appearance?: ButtonAppearance;
    size?: ButtonSize;
  };
  Blocks: {
    /** Optional visible label rendered before the copy icon. */
    default: [];
  };
}
class UiCopyButtonComponent extends Component<UiCopyButtonSignature> {
  @service declare notifications: NotificationsService;

  get text(): string {
    return this.args.text;
  }

  copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(this.text);
      this.notifications.add('Copied to clipboard', {
        appearance: 'success',
      });
    } catch (e) {
      this.notifications.add('Copy Failed', {
        appearance: 'error',
      });
      console.error(e);
    }
  };

  <template>
    <Button
      data-test-copy-button
      @intent={{if @intent @intent "primary"}}
      @appearance={{if @appearance @appearance "outlined"}}
      @size={{@size}}
      title={{@title}}
      {{on "click" this.copyToClipboard}}
      ...attributes
    >
      {{! A label makes the control self-describing and widens the click target;
          without one the icon alone still carries the whole affordance. }}
      {{yield}}
      <PhFiles @size="16" />
    </Button>
  </template>
}

export default UiCopyButtonComponent;
